import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData, NumberFormatKind } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type NumberPreviewProps = {
  questionIndex: number;
};
const NumberPreview = t0 => {
  const $ = _c(29);
  const {
    questionIndex
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  const t3 = `questions.${questionIndex}.numberFormat`;
  const t4 = `questions.${questionIndex}.currencyCode`;
  const t5 = `questions.${questionIndex}.placeholder`;
  let t6;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5) {
    t6 = [t1, t2, t3, t4, t5];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== control || $[7] !== t6) {
    t7 = {
      control,
      name: t6
    };
    $[6] = control;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [label, required, numberFormat, currencyCode, placeholder] = useWatch(t7) as [string, boolean, NumberFormatKind, string, string | undefined];
  let t8;
  if ($[9] !== t) {
    t8 = trimmed => t(_temp, {
      label: trimmed
    });
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== label || $[12] !== required || $[13] !== t8) {
    t9 = previewLabel(label, required, t8);
    $[11] = label;
    $[12] = required;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const labelWithOptional = t9;
  const isCurrency = numberFormat === "currency";
  let t10;
  if ($[15] !== labelWithOptional) {
    t10 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[15] = labelWithOptional;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `questions.${questionIndex}.preview`;
  let t12;
  if ($[17] !== placeholder || $[18] !== t) {
    t12 = placeholder || t(_temp2);
    $[17] = placeholder;
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== currencyCode || $[21] !== isCurrency) {
    t13 = isCurrency ? getCurrencySymbol(currencyCode) : undefined;
    $[20] = currencyCode;
    $[21] = isCurrency;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = isCurrency ? 2 : 0;
  let t15;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t15 = <Form.Number label={t10} name={t11} placeholder={t12} addon={t13} decimalPlaces={t14} />;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
const getCurrencySymbol = (code?: string): string => {
  if (code?.toLowerCase() === 'usd' || !code) {
    return '$';
  }
  return code.toUpperCase();
};
export default NumberPreview;
function _temp($) {
  return $.preview.labelOptional;
}
function _temp2($_0) {
  return $_0.preview.yourAnswer;
}